export enum UserRegion {
  USA = 'USA',
  APAC = 'APAC',
  EMEA = 'EMEA',
  LATAM = 'LATAM',
}

const countryToRegionMap: Record<string, UserRegion> = {
  // EMEA (Europe, Middle East, Africa)
  ad: UserRegion.EMEA,
  ae: UserRegion.EMEA,
  af: UserRegion.EMEA,
  al: UserRegion.EMEA,
  am: UserRegion.EMEA,
  ao: UserRegion.EMEA,
  aq: UserRegion.EMEA,
  at: UserRegion.EMEA,
  ax: UserRegion.EMEA,
  az: UserRegion.EMEA,
  ba: UserRegion.EMEA,
  be: UserRegion.EMEA,
  bf: UserRegion.EMEA,
  bg: UserRegion.EMEA,
  bh: UserRegion.EMEA,
  bi: UserRegion.EMEA,
  bj: UserRegion.EMEA,
  bl: UserRegion.EMEA,
  bv: UserRegion.EMEA,
  bw: UserRegion.EMEA,
  by: UserRegion.EMEA,
  cd: UserRegion.EMEA,
  cf: UserRegion.EMEA,
  cg: UserRegion.EMEA,
  ch: UserRegion.EMEA,
  ci: UserRegion.EMEA,
  ck: UserRegion.EMEA,
  cm: UserRegion.EMEA,
  cv: UserRegion.EMEA,
  cw: UserRegion.EMEA,
  cy: UserRegion.EMEA,
  cz: UserRegion.EMEA,
  de: UserRegion.EMEA,
  dj: UserRegion.EMEA,
  dk: UserRegion.EMEA,
  dz: UserRegion.EMEA,
  ee: UserRegion.EMEA,
  eg: UserRegion.EMEA,
  eh: UserRegion.EMEA,
  er: UserRegion.EMEA,
  es: UserRegion.EMEA,
  et: UserRegion.EMEA,
  fi: UserRegion.EMEA,
  fo: UserRegion.EMEA,
  fr: UserRegion.EMEA,
  ga: UserRegion.EMEA,
  gb: UserRegion.EMEA,
  ge: UserRegion.EMEA,
  gf: UserRegion.EMEA,
  gg: UserRegion.EMEA,
  gh: UserRegion.EMEA,
  gi: UserRegion.EMEA,
  gl: UserRegion.EMEA,
  gm: UserRegion.EMEA,
  gn: UserRegion.EMEA,
  gp: UserRegion.EMEA,
  gq: UserRegion.EMEA,
  gr: UserRegion.EMEA,
  gw: UserRegion.EMEA,
  hm: UserRegion.EMEA,
  hr: UserRegion.EMEA,
  hu: UserRegion.EMEA,
  ie: UserRegion.EMEA,
  il: UserRegion.EMEA,
  im: UserRegion.EMEA,
  iq: UserRegion.EMEA,
  ir: UserRegion.EMEA,
  is: UserRegion.EMEA,
  it: UserRegion.EMEA,
  je: UserRegion.EMEA,
  jo: UserRegion.EMEA,
  ke: UserRegion.EMEA,
  kg: UserRegion.EMEA,
  km: UserRegion.EMEA,
  kw: UserRegion.EMEA,
  kz: UserRegion.EMEA,
  lb: UserRegion.EMEA,
  li: UserRegion.EMEA,
  lr: UserRegion.EMEA,
  ls: UserRegion.EMEA,
  lt: UserRegion.EMEA,
  lu: UserRegion.EMEA,
  lv: UserRegion.EMEA,
  ly: UserRegion.EMEA,
  ma: UserRegion.EMEA,
  mc: UserRegion.EMEA,
  md: UserRegion.EMEA,
  me: UserRegion.EMEA,
  mf: UserRegion.EMEA,
  mg: UserRegion.EMEA,
  mk: UserRegion.EMEA,
  ml: UserRegion.EMEA,
  mq: UserRegion.EMEA,
  mr: UserRegion.EMEA,
  mt: UserRegion.EMEA,
  mu: UserRegion.EMEA,
  mw: UserRegion.EMEA,
  mz: UserRegion.EMEA,
  na: UserRegion.EMEA,
  nc: UserRegion.EMEA,
  ne: UserRegion.EMEA,
  ng: UserRegion.EMEA,
  nl: UserRegion.EMEA,
  no: UserRegion.EMEA,
  om: UserRegion.EMEA,
  pf: UserRegion.EMEA,
  pl: UserRegion.EMEA,
  pm: UserRegion.EMEA,
  ps: UserRegion.EMEA,
  pt: UserRegion.EMEA,
  qa: UserRegion.EMEA,
  re: UserRegion.EMEA,
  ro: UserRegion.EMEA,
  rs: UserRegion.EMEA,
  ru: UserRegion.EMEA,
  rw: UserRegion.EMEA,
  sa: UserRegion.EMEA,
  sc: UserRegion.EMEA,
  sd: UserRegion.EMEA,
  se: UserRegion.EMEA,
  sh: UserRegion.EMEA,
  si: UserRegion.EMEA,
  sj: UserRegion.EMEA,
  sk: UserRegion.EMEA,
  sl: UserRegion.EMEA,
  sm: UserRegion.EMEA,
  sn: UserRegion.EMEA,
  so: UserRegion.EMEA,
  ss: UserRegion.EMEA,
  st: UserRegion.EMEA,
  sz: UserRegion.EMEA,
  tc: UserRegion.EMEA,
  td: UserRegion.EMEA,
  tf: UserRegion.EMEA,
  tg: UserRegion.EMEA,
  tn: UserRegion.EMEA,
  tr: UserRegion.EMEA,
  ua: UserRegion.EMEA,
  ug: UserRegion.EMEA,
  va: UserRegion.EMEA,
  wf: UserRegion.EMEA,
  ye: UserRegion.EMEA,
  yt: UserRegion.EMEA,
  za: UserRegion.EMEA,
  zm: UserRegion.EMEA,
  zw: UserRegion.EMEA,
  ca: UserRegion.EMEA,

  // USA (United States only)
  us: UserRegion.USA,

  // LATAM (Latin America)
  ag: UserRegion.LATAM,
  ai: UserRegion.LATAM,
  ar: UserRegion.LATAM,
  aw: UserRegion.LATAM,
  bb: UserRegion.LATAM,
  bm: UserRegion.LATAM,
  bo: UserRegion.LATAM,
  br: UserRegion.LATAM,
  bs: UserRegion.LATAM,
  bz: UserRegion.LATAM,
  cl: UserRegion.LATAM,
  co: UserRegion.LATAM,
  cr: UserRegion.LATAM,
  cu: UserRegion.LATAM,
  dm: UserRegion.LATAM,
  do: UserRegion.LATAM,
  ec: UserRegion.LATAM,
  fk: UserRegion.LATAM,
  gd: UserRegion.LATAM,
  gs: UserRegion.LATAM,
  gt: UserRegion.LATAM,
  gy: UserRegion.LATAM,
  hn: UserRegion.LATAM,
  ht: UserRegion.LATAM,
  jm: UserRegion.LATAM,
  kn: UserRegion.LATAM,
  ky: UserRegion.LATAM,
  lc: UserRegion.LATAM,
  ms: UserRegion.LATAM,
  mx: UserRegion.LATAM,
  ni: UserRegion.LATAM,
  pa: UserRegion.LATAM,
  pe: UserRegion.LATAM,
  pr: UserRegion.LATAM,
  py: UserRegion.LATAM,
  sr: UserRegion.LATAM,
  sv: UserRegion.LATAM,
  sx: UserRegion.LATAM,
  tt: UserRegion.LATAM,
  uy: UserRegion.LATAM,
  vc: UserRegion.LATAM,
  ve: UserRegion.LATAM,
  vg: UserRegion.LATAM,
  vi: UserRegion.LATAM,

  // APAC (Asia-Pacific)
  as: UserRegion.APAC,
  au: UserRegion.APAC,
  bd: UserRegion.APAC,
  bn: UserRegion.APAC,
  bt: UserRegion.APAC,
  cc: UserRegion.APAC,
  cn: UserRegion.APAC,
  cx: UserRegion.APAC,
  fj: UserRegion.APAC,
  fm: UserRegion.APAC,
  gu: UserRegion.APAC,
  hk: UserRegion.APAC,
  id: UserRegion.APAC,
  in: UserRegion.APAC,
  io: UserRegion.APAC,
  jp: UserRegion.APAC,
  kh: UserRegion.APAC,
  ki: UserRegion.APAC,
  kp: UserRegion.APAC,
  kr: UserRegion.APAC,
  la: UserRegion.APAC,
  lk: UserRegion.APAC,
  mh: UserRegion.APAC,
  mm: UserRegion.APAC,
  mn: UserRegion.APAC,
  mo: UserRegion.APAC,
  mp: UserRegion.APAC,
  mv: UserRegion.APAC,
  my: UserRegion.APAC,
  nf: UserRegion.APAC,
  np: UserRegion.APAC,
  nr: UserRegion.APAC,
  nu: UserRegion.APAC,
  nz: UserRegion.APAC,
  pg: UserRegion.APAC,
  ph: UserRegion.APAC,
  pk: UserRegion.APAC,
  pn: UserRegion.APAC,
  pw: UserRegion.APAC,
  sb: UserRegion.APAC,
  sg: UserRegion.APAC,
  th: UserRegion.APAC,
  tj: UserRegion.APAC,
  tk: UserRegion.APAC,
  tl: UserRegion.APAC,
  tm: UserRegion.APAC,
  to: UserRegion.APAC,
  tv: UserRegion.APAC,
  tw: UserRegion.APAC,
  uz: UserRegion.APAC,
  vn: UserRegion.APAC,
  vu: UserRegion.APAC,
  ws: UserRegion.APAC,
};

export const getRegionByCountryCode = (countryCode: string): UserRegion | null => {
  return countryToRegionMap[countryCode.toLowerCase()] || null;
};
